import React from 'react'
import { Alert } from 'react-bootstrap'

// children is the text inside the "<Message> </Message>" tag
const Message = ({ variant, children }) => {
  return <Alert variant={variant}>{children}</Alert>
}

Message.defaultProps = {
  variant: 'info',
}

export default Message
